angular.module('agreements')
    .component('agreementSummary', {
        bindings: {
            agreement: '<',
            noAgreement: '<',
            type: '@',
        },
        templateUrl: 'app/agreements/agreement-summary.html',
        controller: function ($scope, Principal, AgreementService) {
            this.openAgreement = (id) => {
                AgreementService.open(id)
            }

            this.canReadAgreement = () => {
                return Principal.hasAnyAuthority(['ROLE_CONTRACT_MODULE'])
            }
        }
    })
